import React, { useState } from "react";
import {
  routesAdminData,
  routesClientData,
  baseAdminPath,
  baseClientPath,
} from "./routes";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Spin } from "antd";
import Layout from "./components/layout/index";
import AdminLayout from "./components/layout/adminLayout";
import ClientLayout from "./components/layout/clientLayout";
import Login from "./pages/login/index";
import NotFound from "./pages/404/index";
import { useSelector, useDispatch } from "react-redux";
import { requestGetInfo } from "./components/layout/service";
import * as types from "./redux/types";
import "./App.less";
const newRoutesAdminData = routesAdminData.reduce((total, curr) => {
  if (curr.children) {
    curr.children.forEach((item) => {
      total.push({
        ...item,
        path: `/${baseAdminPath}/${curr.path}/${item.path}`,
      });
    });
  } else {
    total.push({
      ...curr,
      path: `/${baseAdminPath}/${curr.path}`,
    });
  }
  return total;
}, []);

const newRoutesClientData = routesClientData.reduce((total, curr) => {
  if (curr.children) {
    curr.children.forEach((item) => {
      total.push({
        ...item,
        path: `/${baseClientPath}/${curr.path}/${item.path}`,
      });
    });
  } else {
    total.push({
      ...curr,
      path: `/${baseClientPath}/${curr.path}`,
    });
  }
  return total;
}, []);
const RouterComponent = () => {
  return (
    <Router>
      <RoutesComponent />
    </Router>
  );
};

const RoutesComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const [globalLoading, changeGlobalLoading] = useState(true);
  React.useEffect(() => {
    if (location.pathname === "/login") {
      changeGlobalLoading(false);
      return;
    }
    getUserInfo();
  }, []);
  const getUserInfo = async () => {
    changeGlobalLoading(true);
    const res = await requestGetInfo();
    if (res.code === 0) {
      changeGlobalLoading(false);
      dispatch({
        type: types.CHANGE_USERINFO,
        payload: res.data,
      });
      console.log("location.pathname", window.location.pathname);
      // 如果当前路由是基础路由/则根据角色跳转不同页面
      if (window.location.pathname === "/") {
        navigate(res.data.roleLevel <= 2 ? "/admin/lotteryManage/lotteryPolymerize" : "/client/cashier");
      }
    }
  };
  return (
    <>
      {globalLoading && (
        <Spin
          spinning={true}
          size="large"
          style={{ width: "100vw", marginTop: 280 }}
        />
      )}
      {!globalLoading && (
        <Routes>
          <Route
            path="/login"
            element={<Login getUserInfo={getUserInfo} />}
          ></Route>
          <Route path="/" element={<Layout />}>
            {userInfo.roleLevel <= 2 && (
              <Route path={`/${baseAdminPath}`} element={<AdminLayout />}>
                {newRoutesAdminData.map((item) => (
                  <Route
                    key={item.path}
                    path={item.path}
                    element={item.element}
                  ></Route>
                ))}
                <Route
                  path={`/${baseAdminPath}/*`}
                  element={<NotFound />}
                ></Route>
              </Route>
            )}
            {userInfo.roleLevel > 2 && (
              <Route path={`/${baseClientPath}`} element={<ClientLayout />}>
                {newRoutesClientData.map((item) => (
                  <Route
                    key={item.path}
                    path={item.path}
                    element={item.element}
                  ></Route>
                ))}
                <Route
                  path={`/${baseClientPath}/*`}
                  element={<NotFound />}
                ></Route>
              </Route>
            )}
          </Route>
          <Route path="/*" element={<NotFound />}></Route>
        </Routes>
      )}
    </>
  );
};

export default RouterComponent;
